import type { DockviewApi } from "dockview"

/**
 * Dockview's API instance exposes a non-public `component` reference used for layout internals.
 */
export function getDockviewInnerComponent(api: DockviewApi): unknown {
  return (api as unknown as { component?: unknown }).component
}
